<template>
  <div>
    <p v-if="!report" class="has-text-grey">No report received yet.</p>
    <template v-else>
      <div class="columns is-multiline is-mobile">
        <div v-for="row in details" :key="row.label" class="column is-half-mobile is-one-third-tablet">
          <p class="is-size-7 has-text-grey">{{ row.label }}</p>
          <p class="detail-value">{{ row.value }}</p>
        </div>
      </div>

      <h3 class="title is-6">Hardware</h3>
      <table v-if="hardware.length" class="table is-fullwidth is-narrow">
        <tbody>
          <tr v-for="[name, value] in hardware" :key="name">
            <th>{{ name }}</th>
            <td class="detail-value">{{ value }}</td>
          </tr>
        </tbody>
      </table>
      <p v-else class="has-text-grey">No hardware details reported.</p>

      <template v-if="events.length">
        <h3 class="title is-6 mt-4">Arduino events</h3>
        <table class="table is-fullwidth is-narrow is-striped">
          <tbody>
            <tr v-for="(event, i) in events" :key="i">
              <td>{{ event.time }}</td>
              <td>{{ event.text }}</td>
              <td>{{ event.voltage }}</td>
            </tr>
          </tbody>
        </table>
      </template>

      <details class="mt-4">
        <summary>Raw report</summary>
        <pre>{{ JSON.stringify(report, null, 2) }}</pre>
      </details>
    </template>
  </div>
</template>

<script>
import { formatDate } from "@/utils/date_converter";
import { arduinoEvents, arduinoSummary } from "@/utils/pro_camera";

export default {
  name: "ProCameraReportTab",
  props: {
    deviceData: { type: Object, default: () => ({}) },
  },
  computed: {
    report() {
      return this.deviceData.last_report;
    },
    details() {
      const report = this.report;
      const camera = typeof report.camera === "object" ? JSON.stringify(report.camera) : report.camera;
      const power = report.low_voltage
        ? "Low voltage"
        : report.throttled === "0x0" || report.throttled === false
        ? "Normal"
        : report.throttled;
      return [
        { label: "Received", value: formatDate(this.deviceData.last_seen_at) },
        { label: "Camera", value: camera },
        { label: "Pending Files", value: report.pending_files },
        {
          label: "Free Disk",
          value: report.disk_free_kb ? `${(report.disk_free_kb / 1048576).toFixed(2)} GB` : "",
        },
        { label: "Power", value: power },
        { label: "Arduino", value: arduinoSummary(report.arduino_sync) },
        { label: "Next Wake", value: formatDate(this.deviceData.next_wake_at) },
      ].map((row) => ({ ...row, value: row.value === 0 ? 0 : row.value || "—" }));
    },
    hardware() {
      return Object.entries(this.report.parts || this.deviceData.hardware_fingerprint || {}).filter(
        ([, value]) => value
      );
    },
    events() {
      return arduinoEvents(this.report.arduino_events);
    },
  },
};
</script>

<style scoped>
.detail-value { overflow-wrap: anywhere; }
</style>
